import { Box, Center, useUIContext } from "@msuite/picasso";
import { motion } from "framer-motion";
import { useId } from "react";

/** Props Interface */
interface CanvasQuestionpageImagesWrapperProps {
	children: React.ReactNode;
	isSelected?: boolean;
	onClick?: () => void;
}

export function CanvasQuestionPageImagesWrapper({
	children,
	onClick,
	isSelected,
}: CanvasQuestionpageImagesWrapperProps) {
	const { colors } = useUIContext();
	const renderId = useId();

	return (
		<Center
			layoutId={renderId}
			as={motion.div}
			bg={colors.grayLight}
			borderWidth={0.5}
			rounded="xl"
			style={{
				aspectRatio: "1 / 1.5",
			}}
			cursor="pointer"
			whileTap={{
				scale: 0.98,
			}}
			flexDirection="column"
			gap={3}
			overflow="hidden"
			onClick={onClick}
			position="relative"
		>
			{children}
			{isSelected && (
				<Box
					position="absolute"
					left={0}
					right={0}
					bottom={0}
					top={0}
					borderWidth={4}
					rounded="xl"
					borderColor={colors.blue}
				/>
			)}
		</Center>
	);
}
